// tslint:disable
/**
 * Sprungkraft Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BookingColumn {
    KursNr = 'KURS_NR',
    KursId = 'KURS_ID',
    Kurszeitraum = 'KURSZEITRAUM',
    Anrede = 'ANREDE',
    Nachname = 'NACHNAME',
    Vorname = 'VORNAME',
    Geburtsdatum = 'GEBURTSDATUM',
    Krankenkasse = 'KRANKENKASSE',
    Email = 'EMAIL',
    Telefon = 'TELEFON',
    Kursgebuehr = 'KURSGEBUEHR',
    Buchungszeitpunkt = 'BUCHUNGSZEITPUNKT',
    Storno = 'STORNO',
    Rueckerstattung = 'RUECKERSTATTUNG',
    InfosTrainer = 'INFOS_TRAINER',
    Teilnahmebeschein = 'TEILNAHMEBESCHEIN',
    Kursnewsletter = 'KURSNEWSLETTER',
    Strasse = 'STRASSE',
    Hausnummer = 'HAUSNUMMER',
    Plz = 'PLZ',
    Ort = 'ORT'
}

